(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  // Header Logo/Wordmark Transition
  document.addEventListener('DOMContentLoaded', function() {
    const headerLogoLink = document.getElementById('header-logo-link');
    const headerWordmarkLink = document.getElementById('header-wordmark-link');
    
    // Check if we're on the homepage
    const isHomepage = document.body.classList.contains('template-index') || window.location.pathname === '/' || window.location.pathname === '/index';
    
    // Add template class to body for CSS targeting if on homepage
    if (isHomepage) {
      document.body.classList.add('template-index');
    }
    
    // If we're not on homepage, show header logo and hide wordmark
    if (!isHomepage) {
      if (headerLogoLink) {
        headerLogoLink.style.opacity = 1;
        headerLogoLink.classList.remove('hidden');
        headerLogoLink.classList.add('visible');
      }
      if (headerWordmarkLink) {
        headerWordmarkLink.style.opacity = 0;
        headerWordmarkLink.classList.add('hidden');
      }
      return;
    }
    
    if (!headerLogoLink || !headerWordmarkLink) {
      console.log('Header logo elements not found');
      return;
    }
    
    // Get the banner section (hero section)
    const bannerSection = document.querySelector('.banner');
    if (!bannerSection) {
      // If no banner section, show logo and hide wordmark
      headerLogoLink.style.opacity = 1;
      headerLogoLink.classList.remove('hidden');
      headerLogoLink.classList.add('visible');
      headerWordmarkLink.style.opacity = 0;
      headerWordmarkLink.classList.add('hidden');
      return;
    }
    
    let bannerHeight = bannerSection.offsetHeight;
    let periodicSwitchInterval = null;
    let isShowingWordmark = true;
    
    function updateHeaderLogoVisibility() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollProgress = Math.min(scrollTop / bannerHeight, 1);
      
      // Start transition when user starts scrolling (even 1px)
      if (scrollTop > 0) {
        // Clear periodic switching when scrolling
        if (periodicSwitchInterval) {
          clearInterval(periodicSwitchInterval);
          periodicSwitchInterval = null;
        }
        
        // Smooth transition from wordmark to logo
        const fadeProgress = Math.min(scrollTop / 150, 1); // Complete transition over 150px scroll
        
        // Logo fades in
        headerLogoLink.style.opacity = fadeProgress;
        headerLogoLink.classList.remove('hidden');
        headerLogoLink.classList.add('visible');
        
        // Wordmark fades out
        headerWordmarkLink.style.opacity = 1 - fadeProgress;
        if (fadeProgress >= 1) {
          headerWordmarkLink.classList.add('hidden');
        } else {
          headerWordmarkLink.classList.remove('hidden');
        }
      } else {
        // At top: start periodic switching if not already started
        if (!periodicSwitchInterval) {
          startPeriodicSwitching();
        }
      }
    }
    
    function startPeriodicSwitching() {
      // Clear any existing interval
      if (periodicSwitchInterval) {
        clearInterval(periodicSwitchInterval);
      }
      
      // Set initial state to wordmark
      isShowingWordmark = true;
      headerLogoLink.style.opacity = 0;
      headerLogoLink.classList.add('hidden');
      headerLogoLink.classList.remove('visible');
      headerWordmarkLink.style.opacity = 1;
      headerWordmarkLink.classList.remove('hidden');
      
      // Start periodic switching every 2 seconds
      periodicSwitchInterval = setInterval(function() {
        if (isShowingWordmark) {
          // Switch to logo - hide wordmark first, then show logo
          headerWordmarkLink.style.opacity = 0;
          
          setTimeout(() => {
            headerWordmarkLink.classList.add('hidden');
            headerLogoLink.classList.remove('hidden');
            headerLogoLink.classList.add('visible');
            headerLogoLink.style.opacity = 1;
          }, 300);
          
          isShowingWordmark = false;
        } else {
          // Switch to wordmark - hide logo first, then show wordmark
          headerLogoLink.style.opacity = 0;
          
          setTimeout(() => {
            headerLogoLink.classList.add('hidden');
            headerLogoLink.classList.remove('visible');
            headerWordmarkLink.classList.remove('hidden');
            headerWordmarkLink.style.opacity = 1;
          }, 300);
          
          isShowingWordmark = true;
        }
      }, 2000);
    }
    
    // Initial call
    updateHeaderLogoVisibility();
    
    // Add scroll listener with performance optimization
    let ticking = false;
    function requestTick() {
      if (!ticking) {
        requestAnimationFrame(function() {
          updateHeaderLogoVisibility();
          ticking = false;
        });
        ticking = true;
      }
    }
    
    window.addEventListener('scroll', requestTick);
    
    // Update on resize
    window.addEventListener('resize', function() {
      const newBannerHeight = bannerSection.offsetHeight;
      if (newBannerHeight !== bannerHeight) {
        bannerHeight = newBannerHeight;
        updateHeaderLogoVisibility();
      }
    });
    
    // Clean up interval on page unload
    window.addEventListener('beforeunload', function() {
      if (periodicSwitchInterval) {
        clearInterval(periodicSwitchInterval);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
  // Hero Logo Scroll Animation and Parallax Effect
  document.addEventListener('DOMContentLoaded', function() {
    const heroLogoOverlay = document.getElementById('hero-logo-overlay');
    const header = document.querySelector('.header');
    const heroSection = document.querySelector('.banner');
    
    if (!heroSection) {
      console.log('Hero section not found');
      return;
    }
    
    // Mobile button positioning for two-image banners
    function positionMobileButtons() {
      if (window.innerWidth > 749) return; // Only on mobile
      
      const banner = heroSection;
      const isStacked = banner.classList.contains('banner--stacked');
      const leftButton = banner.querySelector('.banner__buttons--left');
      const rightButton = banner.querySelector('.banner__buttons--right');
      const mediaHalves = banner.querySelectorAll('.banner__media-half');
      
      if (!leftButton || !rightButton || mediaHalves.length !== 2) return;
      
      if (isStacked) {
        // For stacked images, position buttons at bottom of their respective images
        const firstImage = mediaHalves[0];
        const secondImage = mediaHalves[1];
        
        if (firstImage && secondImage) {
          const firstImageBottom = firstImage.offsetTop + firstImage.offsetHeight;
          const secondImageBottom = secondImage.offsetTop + secondImage.offsetHeight;
          
          leftButton.style.top = (firstImageBottom - 60) + 'px';
          leftButton.style.bottom = 'auto';
          
          rightButton.style.top = (secondImageBottom - 60) + 'px';
          rightButton.style.bottom = 'auto';
        }
      } else {
        // For side-by-side, use CSS positioning
        leftButton.style.top = 'auto';
        leftButton.style.bottom = '2rem';
        rightButton.style.top = 'auto';
        rightButton.style.bottom = '2rem';
      }
    }
    
    // Position buttons on load and resize
    positionMobileButtons();
    window.addEventListener('resize', positionMobileButtons);
    
    // Also position after images load
    const images = banner.querySelectorAll('.banner__media img');
    images.forEach(img => {
      if (img.complete) {
        positionMobileButtons();
      } else {
        img.addEventListener('load', positionMobileButtons);
      }
    });
    
    // Add parallax class to hero section
    heroSection.classList.add('banner--parallax');
    
    // Get banner media elements for parallax
    const bannerMedia = heroSection.querySelector('.banner__media');
    const bannerImages = heroSection.querySelectorAll('.banner__media img, .banner__media picture');
    
    let heroHeight = heroSection.offsetHeight;
    let headerHeight = header ? header.offsetHeight : 0;
    
    function updateLogoPosition() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollProgress = Math.min(scrollTop / heroHeight, 1);
      
      // Parallax effect for background images
      if (bannerMedia && bannerImages.length > 0) {
        // Calculate parallax offset - background moves slower than scroll
        const parallaxSpeed = 0.25; // Adjust this value to control parallax speed (0.5 = half speed)
        const parallaxOffset = scrollTop * parallaxSpeed;
        
        // Apply parallax transform to background images
        bannerImages.forEach(function(img) {
          img.style.transform = `translate3d(0, ${parallaxOffset}px, 0)`;
        });
      }
      
      // Hero logo animation (only if logo overlay exists)
      if (heroLogoOverlay && header) {
        if (scrollProgress > 0) {
          heroLogoOverlay.classList.add('scrolling');
        } else {
          heroLogoOverlay.classList.remove('scrolling');
        }
        
        if (scrollProgress >= 1) {
          heroLogoOverlay.classList.add('scrolled');
        } else {
          heroLogoOverlay.classList.remove('scrolled');
          
          // Calculate new position and size with easing
          const easeOutCubic = 1 - Math.pow(1 - scrollProgress, 3);
          
          // Calculate scale to match header logo size based on screen size
          const isMobile = window.innerWidth <= 749;
          const heroLogoSize = isMobile ? 192 : 320; // 12rem = 192px on mobile, 20rem = 320px on desktop
          const headerLogoSize = isMobile ? 32 : 40; // 2rem = 32px on mobile, 2.5rem = 40px on desktop
          const targetScale = headerLogoSize / heroLogoSize;
          
          // Ensure both logos have same size at 25% scroll (when header logo starts appearing)
          const handoffPoint = 0.25;
          let scale;
          if (scrollProgress >= handoffPoint) {
            // At and after handoff point, hero logo should be exactly header logo size
            scale = targetScale;
          } else {
            // Before handoff point, scale down gradually
            scale = 1 - (easeOutCubic * (1 - targetScale));
          }
          
          const translateY = easeOutCubic * (heroHeight / 2 - headerHeight / 2);
          
          heroLogoOverlay.style.transform = `translate(-50%, calc(-50% - ${translateY}px)) scale(${scale})`;
          
          // Make hero logo fade out before header logo appears
          if (scrollProgress >= 0.15) {
            const finalFadeProgress = (scrollProgress - 0.15) / 0.2; // 0 to 1 over 15-35% scroll
            heroLogoOverlay.style.opacity = 0.9 - (finalFadeProgress * 0.9); // Fade out completely
          } else {
            heroLogoOverlay.style.opacity = 0.9 - (easeOutCubic * 0.1); // Keep more opacity initially
          }
        }
      }
    }
    
    // Initial call
    updateLogoPosition();
    
    // Add scroll listener with performance optimization
    let ticking = false;
    function requestTick() {
      if (!ticking) {
        requestAnimationFrame(function() {
          updateLogoPosition();
          ticking = false;
        });
        ticking = true;
      }
    }
    
    window.addEventListener('scroll', requestTick);
    
    // Update on resize
    window.addEventListener('resize', function() {
      const newHeroHeight = heroSection.offsetHeight;
      const newHeaderHeight = header ? header.offsetHeight : 0;
      
      if (newHeroHeight !== heroHeight || newHeaderHeight !== headerHeight) {
        heroHeight = newHeroHeight;
        headerHeight = newHeaderHeight;
        updateLogoPosition();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
